import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import Project from 'src/entities/Project';
import { getProject, GetProjectAction } from 'src/actions/project/get/GetProject.actions';
import { match } from 'react-router';
import ShowProjectComponent from 'src/modules/project/ShowProject.component';
import {
  getProjectInterested,
  GetProjectInterestedAction
} from 'src/actions/project/interested/get/GetProjectInterested.actions';
import {
  createProjectInterested,
  CreateProjectInterestedAction
} from 'src/actions/project/interested/create/CreateProjectInterested.actions';
import {
  getProjectInvested,
  GetProjectInvestedAction
} from 'src/actions/project/investment/get/GetProjectInvested.actions';
import { getInvestment, GetInvestmentAction } from 'src/actions/investment/get/GetInvestment.actions';
import * as getInvestmentTypes from 'src/actions/investment/get/Types';
import Investment from 'src/entities/Investment';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import Person from 'src/entities/Person';
import User from 'src/entities/User';
import * as getProjectTypes from 'src/actions/project/get/Types';
import { setInvestmentData, SetInvestmentDataAction } from 'src/actions/investment/set-data/SetInvestmentData.actions';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import ProjectDocument from 'src/entities/ProjectDocument';
import Payment from 'src/entities/Payment';
import { getPayment, GetPaymentAction } from 'src/actions/payment/get/GetPayment.actions';

interface StateProps {
  project?: Project;
  isLogged: boolean;
  loggedUserData: number | null;
  projectInterested?: Person[];
  activeProfile?: Person;
  interestedUser: boolean;
  investedUser: boolean;
  projectInvested?: Person[];
  investment?: Investment;
  payment?: Payment;
  user: User | undefined;
}

interface DispatchProps {
  getUser: (userId: number) => Promise<GetUserAction>;

  getProject: (projectId: number) => Promise<GetProjectAction>;

  getProjectInterested(projectId: number, personId: number, personType: string): void;

  createProjectInterested(projectId: number, person: Person): Promise<CreateProjectInterestedAction>;

  getProjectInvested(projectId: number, personId: number, personType: string): void;

  getInvestment(projectId: number, personId: number, personType: string): Promise<GetInvestmentAction>;

  setInvestmentData(investment?: Investment): SetInvestmentDataAction;

  getPayment(investmentId: number): void;
}

interface OwnProps {
  match: match<{ projectId: number, invest: boolean }>;
}

interface State {
  section: string;
  founder: boolean;
  companyDocument?: ProjectDocument;
}

interface Props extends StateProps, DispatchProps, OwnProps {
}

class ShowProjectContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      section: 'resumen',
      founder: false,
    };
  }

  public componentWillMount(): void {

    this.props.getProject(this.props.match.params.projectId).then((response) => {
      if (response.type === getProjectTypes.GET_PROJECT_SUCCESS) {
        if (this.props.activeProfile) {
          this.checkFounder(this.props.activeProfile);
          this.getProfileRelatedData(this.props);
        } else if (this.props.loggedUserData) {
          this.props.getUser(this.props.loggedUserData).then(() => {
            this.checkFounder(this.props.activeProfile!);
            this.getProfileRelatedData(this.props);
          });
        }
      }
    });
  }

  public componentWillUpdate(newProps: Props) {
    if ((this.props.project !== newProps.project) && (newProps.project)) {
      if (newProps.project!.company.statutes) {
        this.setState({
          companyDocument: new ProjectDocument({
            id: 0,
            url: newProps.project.company.statutes!,
            name: 'Estatutos',
            imageUrl: newProps.project.company.statutesImage!
          })
        });
      }
    }
    if (this.props.match.params.projectId !== newProps.match.params.projectId) {
      this.props.getProject(newProps.match.params.projectId).then((response) => {
        if (response.type === getProjectTypes.GET_PROJECT_SUCCESS) {
          if (this.props.activeProfile) {
            this.checkFounder(this.props.activeProfile);
            this.getProfileRelatedData(this.props);
          } else if (this.props.loggedUserData) {
            this.props.getUser(this.props.loggedUserData).then(() => {
              this.checkFounder(this.props.activeProfile!);
              this.getProfileRelatedData(this.props);
            });
          }
        }
      });
    }
  }

  public checkFounder(profile: Person) {
    if (
      !this.props.project ||
      ((profile.personType === 'physical') && (this.props.project.company.founderId !== profile.id)) ||
      (profile.personType === 'juridical')
    ) {
      this.setState({founder: false});
    } else {
      this.setState({founder: true});
    }
  }

  public componentWillReceiveProps(newProps: Props) {

    if (newProps.investedUser !== this.props.investedUser && newProps.investedUser) {
      this.getProfileRelatedData(newProps);
    }
    if (newProps.investment && this.props.project && newProps.investment &&
      newProps.investment.project!.id === this.props.project!.id &&
      this.props.project.status !== 'Financiado con éxito') {
      this.setState({section: 'formalize'});
    } else {
      this.setState({section: 'resumen'});
    }

    if (this.props.activeProfile !== newProps.activeProfile) {
      this.checkFounder(newProps.activeProfile!);
      this.getProfileRelatedData(newProps);
      this.setState({section: 'resumen'});
    }
  }

  public render(): React.ReactNode {
    return (
      this.props.project ?
        (
          <ShowProjectComponent
            project={this.props.project!}
            isLogged={this.props.isLogged}
            section={this.state.section}
            interestedUser={this.state.founder ? this.state.founder! : this.props.interestedUser!}
            investedUser={this.props.investedUser!}
            activeProfile={this.props.activeProfile!}
            projectInterested={this.props.projectInterested!}
            handleClick={(value: string) => this.handleClick(value)}
            handleInterested={() => this.handleInterested()}
            projectInvested={this.props.projectInvested!}
            investment={this.props.investment}
            companyDocument={this.state.companyDocument}
            invest={this.props.match.params.invest}
            payment={this.props.payment}
          />
        ) :
        <LoadingContainer/>
    );
  }

  private handleClick(value: string): void {
    this.setState({section: value});
  }

  private handleInterested(): void {
    this.props.createProjectInterested(this.props.project!.id, this.props.activeProfile!).then(() => {
      this.props.getProjectInterested(
        this.props.project!.id,
        this.props.activeProfile!.id,
        this.props.activeProfile!.personType
      );
    });
  }

  private getProfileRelatedData(props: Props): void {
    if (!props.activeProfile) {
      return;
    }

    props.getProjectInterested(
      props.match.params.projectId,
      props.activeProfile.id,
      props.activeProfile.personType
    );
    props.getProjectInvested(
      props.match.params.projectId,
      props.activeProfile.id,
      props.activeProfile.personType
    );
    props.getInvestment(
      props.match.params.projectId,
      props.activeProfile.id,
      props.activeProfile.personType
    ).then((response) => {
      if (response.type === getInvestmentTypes.GET_INVESTMENT_SUCCESS && this.props.investment) {
        props.getPayment(this.props.investment.id!);
      }
    });
    props.setInvestmentData(undefined);
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => ({
  getProject: (projectId: number): Promise<GetProjectAction> => (
    dispatch(getProject(projectId))
  ),
  getProjectInterested: (
    projectId: number,
    personId: number,
    personType: string
  ): Promise<GetProjectInterestedAction> => (
    dispatch(getProjectInterested(projectId, personId, personType))
  ),
  createProjectInterested: (projectId: number, person: Person): Promise<CreateProjectInterestedAction> => (
    dispatch(createProjectInterested(projectId, person))
  ),
  getProjectInvested: (
    projectId: number,
    personId: number,
    personType: string
  ): Promise<GetProjectInvestedAction> => (
    dispatch(getProjectInvested(projectId, personId, personType))
  ),
  getInvestment: (
    projectId: number,
    personId: number,
    personType: string
  ): Promise<GetInvestmentAction> => (
    dispatch(getInvestment(projectId, personId, personType))
  ),
  getUser: (userId: number): Promise<GetUserAction> => (
    dispatch(getUser(userId))
  ),
  setInvestmentData: (investment?: Investment): SetInvestmentDataAction => (
    dispatch(setInvestmentData(investment))
  ),
  getPayment: (investmentId: number): Promise<GetPaymentAction> => (
    dispatch(getPayment(investmentId))
  ),
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
  project: state.getProject.project || undefined,
  loggedUserData: state.authentication.loggedUserData,
  isLogged: state.authentication.isLogged,
  activeProfile: state.getUser.activeProfile,
  projectInterested: state.getProjectInterested.projectInterested,
  interestedUser: state.getProjectInterested.interestedUser || false,
  investedUser: state.getProjectInvested.investedUser || false,
  projectInvested: state.getProjectInvested.projectInvested,
  investment: state.getInvestment.investment,
  payment: state.getPayment.payment,
  user: state.getUser.user
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowProjectContainer);



// WEBPACK FOOTER //
// ./src/modules/project/ShowProject.container.tsx